import { render, staticRenderFns } from "./pro-classify-add.vue?vue&type=template&id=7b064730&scoped=true&"
import script from "./pro-classify-add.vue?vue&type=script&lang=js&"
export * from "./pro-classify-add.vue?vue&type=script&lang=js&"
import style0 from "./pro-classify-add.vue?vue&type=style&index=0&id=7b064730&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b064730",
  null
  
)

export default component.exports